import script from "./CheckoutModalUFO.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutModalUFO.vue?vue&type=script&setup=true&lang=js"

const cssModules = {}
import style0 from "./CheckoutModalUFO.vue?vue&type=style&index=0&id=48f3a39a&module=s&lang=scss"
cssModules["s"] = style0

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__